// extracted by mini-css-extract-plugin
module.exports = {"back":"BackArrow_back__Upn-S","backLink":"BackArrow_backLink__YHZGX","backLinkText":"BackArrow_backLinkText__2hBeA"};